import { useUpdateEffect } from 'ahooks';
import { useSelector } from 'umi';

interface IUseUpdateRemoteLangMessage {
  (requestList: any[]): void;
}

const useUpdateRemoteLangMessage: IUseUpdateRemoteLangMessage = (
  requestList,
) => {
  const { currentLang } = useSelector<ReduxState, GlobalState>(
    (state) => state.global,
  );

  useUpdateEffect(() => {
    requestList.forEach((n) => typeof n === 'function' && n());
  }, [currentLang]);
};

export default useUpdateRemoteLangMessage;
